import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export enum MenuKeys {
    'POS',
    'INVENTORY',
    'STAFFING',
    'CRM',
    'FINANCE',
    'RESTAURANT_ADMIN'
}
interface MenuContextType {
    selectedMenuKey: MenuKeys;
    setSelectedMenuKey: (key: MenuKeys) => void;
}

const MenuContext = createContext<MenuContextType | undefined>(undefined);

export const useMenu = () => {
    const context = useContext(MenuContext);
    if (context === undefined) {
        throw new Error('useMenu must be used within a MenuProvider');
    }
    return context;
};

interface MenuProviderProps {
    children: ReactNode;
}

export const MenuProvider: React.FC<MenuProviderProps> = ({ children }) => {
    const [selectedMenuKey, setSelectedMenuKey] = useState<MenuKeys>(MenuKeys.POS);
    const location = useLocation();

    // Auto-detect menu based on current route
    useEffect(() => {
        const path = location.pathname;
        if (path.startsWith('/inventory')) {
            setSelectedMenuKey(MenuKeys.INVENTORY);
        } else if (path.startsWith('/staffing')) {
            setSelectedMenuKey(MenuKeys.STAFFING);
        } else if (path.startsWith('/crm')) {
            setSelectedMenuKey(MenuKeys.CRM);
        } else if (path.startsWith('/finance')) {
            setSelectedMenuKey(MenuKeys.FINANCE);
        } else if (path.startsWith('/pos')) {
            setSelectedMenuKey(MenuKeys.POS);
        } else if (path.startsWith('/restaurant-admin')) {
            setSelectedMenuKey(MenuKeys.RESTAURANT_ADMIN);
        }
    }, [location.pathname]);

    return (
        <MenuContext.Provider value={{ selectedMenuKey, setSelectedMenuKey }}>
            {children}
        </MenuContext.Provider>
    );
};
